import { j as n } from "./chunks/jsx-runtime.mjs";
import { useState as P, useEffect as y } from "react";
import { u as M, a as N, b as T, C as K } from "./chunks/Editor.mjs";
import { b as E, c as $ } from "./chunks/index.mjs";
import { p as i, e } from "./chunks/config.mjs";
import "@vavt/util";
import "codemirror";
import "@codemirror/view";
import "@codemirror/language-data";
import "@codemirror/lang-markdown";
import "@codemirror/state";
import "@codemirror/commands";
import "@codemirror/language";
import "@lezer/highlight";
import "@codemirror/autocomplete";
import "medium-zoom";
import "copy-to-clipboard";
import "markdown-it";
import "markdown-it-image-figures";
import "markdown-it-task-lists";
import "lru-cache";
const _ = (t) => {
  const {
    modelValue: s = e.modelValue,
    theme: a = e.theme,
    className: d = e.className,
    editorId: m = e.editorId,
    showCodeRowNumber: l = e.showCodeRowNumber,
    previewTheme: g = e.previewTheme,
    noMermaid: p = e.noMermaid,
    noKatex: u = e.noKatex,
    onHtmlChanged: c = e.onHtmlChanged,
    onGetCatalog: h = e.onGetCatalog,
    sanitize: f = e.sanitize,
    mdHeadingId: I = e.mdHeadingId,
    noIconfont: w = e.noIconfont,
    noHighlight: x = e.noHighlight,
    noImgZoomIn: C = e.noImgZoomIn,
    language: v = e.language
  } = t, [o] = P(() => ({
    editorId: m,
    noKatex: u,
    noMermaid: p,
    noIconfont: w,
    noHighlight: x
  }));
  M(o);
  const [H, b, r] = N(t);
  return y(() => () => {
    E.clear(m);
  }, []), /* @__PURE__ */ n(
    T.Provider,
    {
      value: {
        editorId: o.editorId,
        tabWidth: 2,
        theme: a,
        language: v,
        highlight: H,
        showCodeRowNumber: l,
        usedLanguageText: b,
        previewTheme: g,
        customIcon: t.customIcon || {}
      },
      children: /* @__PURE__ */ n(
        "div",
        {
          id: o.editorId,
          className: $([
            i,
            d,
            a === "dark" && `${i}-dark`,
            r.fullscreen || r.pageFullscreen ? `${i}-fullscreen` : "",
            `${i}-previewOnly`
          ]),
          style: t.style,
          children: /* @__PURE__ */ n(
            K,
            {
              modelValue: s,
              setting: r,
              mdHeadingId: I,
              onHtmlChanged: c,
              onGetCatalog: h,
              sanitize: f,
              noMermaid: o.noMermaid,
              noHighlight: o.noHighlight,
              noKatex: o.noKatex,
              formatCopiedText: t.formatCopiedText,
              noImgZoomIn: C,
              previewOnly: !0
            },
            "preview-only"
          )
        }
      )
    }
  );
};
export {
  _ as default
};
